<template>
  <ProductCard
    :color-swatches="colorSwatches(product.specifications, productGranularity)"
    data-test="product-card"
    :deal="product.deal"
    :description="
      description(
        product,
        productGranularity,
        i18n(translations.specialOfferType7),
      )
    "
    :discounted-price="product.discountedPrice"
    :extended-description="extendedDescription(productGranularity)"
    :granularity="productGranularity"
    :image-alt="product.title"
    :image-src="product.image"
    :list="tracking.list"
    :listing-id="product.listingId"
    :position="index + 1"
    :price="product.price"
    :price-new="product.priceNew"
    :product
    :review-rating="product.reviewRating"
    :tags="product.marketingTags"
    :title="product.title"
    :url="product.productPageLink"
    :with-starting-from="withStartingFrom(productGranularity)"
    v-on="addToCartListener ? { addToCart: handleAddToCart(product) } : {}"
    @link-click="
      trackProductClick(product, {
        granularity: productGranularity,
        ...tracking,
        position: index + 1,
        source: 'recommendation',
      })
    "
  />
</template>

<script setup lang="ts">
import { getCurrentInstance } from 'vue'

import type { ProductGranularity } from '@backmarket/http-api/src/api-specs-content/models/refined-products'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import {
  type ExtraTrackingData,
  useClickTracking,
} from '../../composables/useProductTracking'
import type { Product } from '../../models/product'
import ProductCard from '../ProductCard/ProductCard.vue'

import translations from './ProductCardCarousel.translations'
import {
  colorSwatches,
  description,
  extendedDescription,
  withStartingFrom,
} from './ProductCardVersion.helper'

withDefaults(
  defineProps<{
    product: Product
    tracking?: ExtraTrackingData
    title?: string
    subtitle?: string
    productGranularity?: ProductGranularity
    index: number
  }>(),
  {
    tracking: () => ({}),
    title: undefined,
    subtitle: undefined,
    productGranularity: undefined,
  },
)

const i18n = useI18n()

const emits = defineEmits<{
  (e: 'add-to-cart', data: { status: string; product: Product }): void
}>()

const addToCartListener = getCurrentInstance()?.vnode.props?.onAddToCart

const { trackProductClick } = useClickTracking()

function handleAddToCart(product: Product) {
  return ({ status }: { status: string }) => {
    emits('add-to-cart', { status, product })
  }
}
</script>
